import { localStoragePolyfill } from './localstorage-polyfill';
import { sessionStoragePolyfill } from './sessionstorage-polyfill';

export default class WebStoragePolyfill {
  constructor(localPoly = localStoragePolyfill, sessionPoly = sessionStoragePolyfill) {
    this._localStoragePolyfill = localPoly;
    this._sessionStoragePolyfill = sessionPoly;
  }

  isLocalStorageAvailable() {
    try { // browsers will throw an error if we try to access a storage object when the user has blocked us from using them
      if (typeof window.localStorage == 'undefined') return false;
    } catch (err) {
      return false;
    }

    try { // hack for safari incognito
      window.localStorage.setItem("storage", "");
      window.localStorage.getItem("storage");
      window.localStorage.removeItem("storage");
      return true;
    } catch (err) {
      return false;
    }
  }

  isSessionStorageAvailable() {
    try { // browsers will throw an error if we try to access a storage object when the user has blocked us from using them
      if (typeof window.sessionStorage == 'undefined') return false;
    } catch (err) {
      return false;
    }

    try { // hack for safari incognito
      window.sessionStorage.setItem("storage", "");
      window.sessionStorage.getItem("storage");
      window.sessionStorage.removeItem("storage");
      return true;
    } catch (err) {
      return false;
    }
  }

  setSessionItem(key, value) {
    if (!this.isSessionStorageAvailable()) return this._sessionStoragePolyfill.setItem(key, value);
    else return window.sessionStorage.setItem(key, value)
  }

  setLocalItem(key, value) {
    if (!this.isLocalStorageAvailable()) return this._localStoragePolyfill.setItem(key, value);
    else return window.localStorage.setItem(key, value);
  }

  getSessionItem(key) {
    if (!this.isSessionStorageAvailable()) return this._sessionStoragePolyfill.getItem(key);
    else return window.sessionStorage.getItem(key);
  }

  getLocalItem(key) {
    if (!this.isLocalStorageAvailable()) return this._localStoragePolyfill.getItem(key);
    else return window.localStorage.getItem(key);
  }

  removeSessionItem(key) {
    if (!this.isSessionStorageAvailable()) return this._sessionStoragePolyfill.removeItem(key);
    else return window.sessionStorage.removeItem(key);
  }

  removeLocalItem(key) {
    if (!this.isLocalStorageAvailable()) return this._localStoragePolyfill.removeItem(key);
    else return window.localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./source/client/data-providers/webstorage-polyfill.js